// extracted by mini-css-extract-plugin
module.exports = {"customizableText":"SigningDialog_customizableText__1hn3c"};